// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__lgUKv","container":"styles_container__ZGOjN","title":"styles_title__12fdj","wrapper":"styles_wrapper__3W6In","answer":"styles_answer__2I6sa"};